module.exports = __webpack_public_path__ + "img/tp-logo-blue.b870877c.png";